import WIDGETS from './widgets.js';
import { store } from '../store.js';
import { getTranslate } from 'react-localize-redux';

const state = store.getState();

export default {
	name: 'ticket_referral',
	id: 'survey_referral',
	spacing: 3,
	widgets: [
		{ content: WIDGETS.TICKET_PATIENT_INFO, breakpoints: { xs: 12 }, lazy_loading: 0, sx: { marginTop: (theme) => theme.spacing(4) } },
		{ content: WIDGETS.TICKET_REFERRAL, breakpoints: { xs: 12 }, lazy_loading: 0 },
	],
};
